export const photoCaptureFailureReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { isContextUpdated: false, failureMessage: action.payload.failureMessage });
};
//# sourceMappingURL=photoCaptureFailureReducer.js.map